// "use client";

// import { useState } from "react";
// import "./StackCardSlider.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faChevronLeft,
//   faChevronRight,
// } from "@fortawesome/free-solid-svg-icons";

// const cards = [
//   {
//     title: "Deep Corporate Integration",
//     description:
//       "Go beyond theory, learn through live industry immersions and corporate partnerships.",
//     image:
//       "https://media.istockphoto.com/id/2105091005/photo/young-student-taking-notes-while-e-learning-on-laptop-at-the-university.jpg?s=612x612&w=0&k=20&c=5AoTWNFmHm-HeQfx0FzB3LPm3MKQXgokYelEvmC_47E=",
//   },
//   {
//     title: "Industry Expert Faculty",
//     description:
//       "Learn from professionals with years of real business experience.",
//     image:
//       "https://thumbs.dreamstime.com/b/african-university-students-group-happy-looking-camera-52803479.jpg",
//   },
//   {
//     title: "Global Learning",
//     description:
//       "International exposure with global universities and internships.",
//     image:
//       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGjnB83_GhAttiayCIDjsE6AKq_yGj4SUUSBpbMcmhaSs3Zq3_NCrNgxY&s",
//   },
//   {
//     title: "AI Driven Curriculum",
//     description: "Future-ready programs designed with Artificial Intelligence.",
//     image:
//       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHSe3cRfKhqtkJZ8q_cDEain9kBbRCuH74Se5KQ-0B8DZSb-G0mae_nio&s",
//   },
// ];

// export default function StackCardSlider() {
//   const [active, setActive] = useState(0);

//   const next = () => {
//     setActive((prev) => (prev + 1) % cards.length);
//   };

//   const prev = () => {
//     setActive((prev) => (prev - 1 + cards.length) % cards.length);
//   };

//   return (
//     <section className="stack_section">
//       <div className="container">
//         <h5>What Sets</h5>
//         <h1>ATLAS Apart</h1>

//         <p>
//           From AI-first learning to global exposure, every experience is
//           designed to give you an edge.
//         </p>
//         <div className="d-flex justify-content-between">
//           <div className="stack_wrapper">
//             {cards.map((card, index) => {
//               const position = (index - active + cards.length) % cards.length;

//               return (
//                 <div
//                   key={index}
//                   className="stack_card"
//                   style={{
//                     zIndex: cards.length - position,
//                     transform: `translateX(-${position * 35}px) scale(${
//                       1 - position * 0.05
//                     })`,
//                     opacity: position > 3 ? 0 : 1,
//                   }}
//                 >
//                   <img src={card.image} alt="" />

//                   <div className="overlay">
//                     <h3>{card.title}</h3>
//                     <p>{card.description}</p>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <div className="stack_buttons">
//             <button onClick={prev}>
//               <FontAwesomeIcon icon={faChevronLeft} />
//             </button>

//             <button onClick={next}>
//               <FontAwesomeIcon icon={faChevronRight} />
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
"use client";

import "./StackCardSlider.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import CommonHeading from "../../common-component/common-heading/CommonHeading";
const cards = [
  {
    title: "Lead Like a Professional",
    description:
      "Develop the confidence to lead through live business projects, client interactions, and real-world decision-making",
    image:
      "/assets/images/online_mba/stackcardslider/leadlikeprofessional.jpg",
  },
  {
    title: "The Real Test of an Idea",
    description:
      "Pitch your ideas to industry experts, receive constructive feedback, and refine your solutions through real-world perspectives.",
    image:
      "/assets/images/online_mba/stackcardslider/realtestofanidea.jpg",
  },
 
  {
    title: "Internships & Global Immersions",
    description: "Explore international business environments and apply your learning through workshops that build confidence, experience, and a global outlook.",
    image:
      "/assets/images/online_mba/stackcardslider/internship&globalimmersion.jpg",
  },
    {
    title: "Industry-Driven Learning",
    description: "Work alongside leading brands on live business challenges, applying classroom concepts to solve real-world problems with industry mentors.",
    image:
      "/assets/images/online_mba/stackcardslider/industrudrivenlearning.jpg",
  },
     {
    title: "Business Begins with People",
    description: "Understand consumer behaviour through field studies and market research that turn observations into opportunities",
    image:
      "/assets/images/online_mba/stackcardslider/businessbeginwithpeople.jpg",
  },
];
export default function StackCardSlider() {
  return (
    <section className="stack_section" id="about">
      <div className="container">
        <CommonHeading
          subTitle="Learning Through"
          title="Industry Experiences"
          description="Designed around real business challenges, the MBA combines simulations, real-time projects, and experiential learning to prepare you for the demands of today's workplace."
        />
        <Swiper
          modules={[Navigation]}
          spaceBetween={28}
          slidesPerView={2.3}
          navigation={{
            nextEl: ".nextBtn",
            prevEl: ".prevBtn",
          }}
          className="py-3"
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1.3,
            },
            992: {
              slidesPerView: 2.3,
            },
          }}
        >
          {cards.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="slider_card">
                <img src={item.image} alt="" />

                <div className="overlay">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="slider_btns">
          <button className="prevBtn">
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <button className="nextBtn">
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </section>
  );
}
